module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    ref: "iframe",
    attrs: {
      "src": _vm.sendSmsUrl,
      "width": "100%",
      "height": "700",
      "frameborder": "0",
      "scrolling": "auto"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-699a00cb!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/nav3/sendsms_hebei.vue
// module id = 758
// module chunks = 2